import { Specialization_ProductVariant as S12nProductVariant } from '__generated__/graphql-types';

import { config } from 'bundles/browse/components/cds/browseTheme';
import type { UpsellProductVariant } from 'bundles/degree-description/types';
import { getProductVariantString } from 'bundles/degree-description/utils/utils';
import type { UpsellsByDegreeSlug } from 'bundles/xddp/types';

import _t from 'i18n!nls/xddp';

type GradientColorKeys = keyof typeof config.colors;

type GradientColorValues = (typeof config.colors)[GradientColorKeys];
export type Gradient = {
  deg: number;
  start: GradientColorValues;
  end: GradientColorValues;
};

const buildDisplayProps = (label: string, courseIds?: string[], gradient?: Gradient) => {
  const defaultGradient = gradient ?? { deg: 135, start: config.colors.blue900, end: config.colors.blue900 };
  if (courseIds && courseIds.length > 0) {
    const courseText = courseIds.length > 1 ? 'Courses' : 'Course';
    return {
      label: _t('#{label} (#{numCourses} #{courseText})', { label, numCourses: courseIds.length, courseText }),
      gradient: defaultGradient,
    };
  }
  return {
    label: _t('#{label}', { label }),
    gradient: defaultGradient,
  };
};

export const getProductDisplayProps = (productVariant: UpsellProductVariant, courseIds?: string[]) => {
  switch (productVariant) {
    case S12nProductVariant.NormalS12N:
      return buildDisplayProps(getProductVariantString(productVariant), courseIds, {
        deg: 135,
        start: config.colors.purple800,
        end: config.colors.purple800,
      });
    case S12nProductVariant.ProfessionalCertificateS12N:
      return buildDisplayProps(getProductVariantString(productVariant), courseIds);
    case 'MasterTrack':
      return buildDisplayProps(getProductVariantString(productVariant), courseIds);
    default:
      return buildDisplayProps('Course', courseIds);
  }
};

export const transformSlugIfNeeded = (slug: string) => {
  return slug === 'master-of-computer-science-illinois' ? 'masters-in-computer-data-science' : slug;
};

export const filterUpsells = (upsells: UpsellsByDegreeSlug) => {
  if (!upsells?.length) return [];
  let filteredUpsells: UpsellsByDegreeSlug = [];
  if (upsells) {
    filteredUpsells = upsells.filter(
      (upsell) =>
        typeof upsell !== null &&
        (upsell.source.upsellProduct?.__typename === 'UpsellQueries_Specialization' ||
          upsell.source.upsellProduct?.__typename === 'UpsellQueries_Mastertrack')
    );
  }
  return filteredUpsells;
};

export const getUpsellInfo = (upsellItem: UpsellsByDegreeSlug) => {
  if (upsellItem && upsellItem[0]) {
    const item = upsellItem[0];

    let upsell;
    let upsellPartners;
    let courseIds;
    let headerImage;
    let logo;

    // if upsell is specialization
    if (
      item?.source?.upsellProduct?.__typename === 'UpsellQueries_Specialization' &&
      item?.source?.upsellProduct?.specializationDetails
    ) {
      upsell = item.source.upsellProduct.specializationDetails;
      upsellPartners = item.source.upsellProduct.partnerEntities || [];
      courseIds = upsell.courses.map((course) => course.id);
      headerImage = upsell.cardImageUrl;
      logo = upsell.partners[0]?.squareLogo;
    }

    // if upsell is mastertrack
    else if (
      item?.source?.upsellProduct?.__typename === 'UpsellQueries_Mastertrack' &&
      item?.source?.upsellProduct?.mastertrack
    ) {
      upsell = item.source.upsellProduct.mastertrack;
      upsellPartners = item.source.upsellProduct.mastertrack.partnerEntities || [];
      courseIds = undefined;
      headerImage = upsell.headerImage;
      logo = upsell.logo;
    } else {
      return null;
    }
    return { upsell, upsellPartners, courseIds, headerImage, logo };
  } else return null;
};
